import http from 'conversations-http/clients/http';
/**
 * @description Fetches the hydrated custom view for the given `customViewId`
 */
export function fetchCustomViewService({
  customViewId
}) {
  return http.get(`conversations-custom-views/v1/custom-views/${customViewId}/hydrated`);
}